import { useParams } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import styles from "../../styles/Blog/IndividualBlog.module.css";
import AddContainer from "../../components/AddComponents/AddContainer";
import SearchTags from "../../components/Blogs/SearchTags";
import TodaysUpdate from "../../components/Blogs/TodaysUpdate";
import Tags from "../../Utils/Tags";
import ThoughtOfTheDay from "../../components/ThoughtOfTheDay/ThoughtOfTheDay";
import Categories from "../../components/Blogs/Categories";
import RecentlyPosted from "../../components/Blogs/RecentlyPosted";
import RecentlyPostedMobile from "../../components/Blogs/MobileComponent/RecentlyPostedMobile";
import "../../styles/HomePage/HomePage.css";
import Loading from "../../components/Loading/Loading";
import formatDate from "../../Utils/FormatDate";
import { base_url, getBlog, getBlogs } from "../../ReuableFunctions/Blogs";
import InstagramPost from "../../components/Blogs/InstagramPost";

const IndividualBlog = () => {
  const [blog, setBlog] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if(window.innerWidth < 768){
      setIsMobile(true);
    }
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Fetch blogs on component mount
    const fetchBlogs = async () => {
      try {
        const blogsFromApi = await getBlogs();
        if (blogsFromApi["returnedRecords"] > 0) {
          setBlogs(blogsFromApi["blogs"]);
        }
      } catch (err) {
        console.error("Error fetching blogs: ", err);
      }
    };
    fetchBlogs();
  }, []);
  const { blogId } = useParams();
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogFromApi = await getBlog(blogId);
        setBlog(blogFromApi);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching blogs: ", err);
        setIsLoading(false);
      }
    };
    fetchBlog();
  }, [blogId]);

  if(isLoading){
    return <Loading />
  }
  return (
    <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
      <>
        <div className={styles.individualBlogContainer}>
          <div className={styles.individualBlogInnerContainer}>
            <div className={styles.individualBlogLeftContainer}>
              <div className={styles.individualBlogLeftCategoryContainer}>
                {blog?.["blogCategory"]?.split(",").map((category, index) => (
                  <span className={styles.category} key={index}>
                    {category}
                  </span>
                ))}
              </div>

              <div className={styles.individualBlogLeftTitle}>
                {blog?.["blogTitle"]}
              </div>
              <div className={styles.infoAndSocialContainer}>
                <div className={styles.infoContainer}>
                  <div className={styles.imageAndNameContainer}>
                    <div className={styles.authorImage}></div>
                    <div className={styles.authorName}>Mohit Valecha</div>
                  </div>
                  <div className={styles.dateContainer}>
                    <div>
                      <img
                        className={styles.icon}
                        src="/calendar.svg"
                        alt="calendar-icon"
                        loading="lazy"
                      />
                    </div>
                    <div>{formatDate(blog?.["createdDate"])}</div>
                  </div>
                  {/* <div className={styles.readContainer}>
                    <div>
                      <img
                        className={styles.icon}
                        src="/time.svg"
                        alt="calendar-icon"
                      />
                    </div>
                    <div>3 min to read</div>
                  </div> */}
                </div>
                <div className={styles.socialContainer}>
                  <a href="https://www.linkedin.com/company/lovencoders/" target="_blank" rel="noreferrer">
                    <img
                      src="/icon-mail.svg"
                      className={styles.invert}
                      alt="linked-logo"
                      loading="lazy"
                    />
                  </a>
                  <a href="/">
                    <img
                      src="/icon-facebook.svg"
                      className={styles.invert}
                      alt="facebook-logo"
                      loading="lazy"
                    />
                  </a>
                  <a href="https://www.instagram.com/personalgrowthhacker/" target="_blank" rel="noreferrer">
                    <img
                      src="/icon-instagram.svg"
                      className={styles.invert}
                      alt="instagram-logo"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>

              <div className={styles.blogImage}>
                <img src={`${base_url}/blog-image/${blog?.["blogId"]}`} className={styles.Image} alt="blog-image" loading="lazy" />
              </div>
              <div className={styles.blogContent}>
                <p>{blog?.["blogDescription"]}</p>
              </div>

              <ThoughtOfTheDay />
              {!isMobile && (
                <div className={styles.recentlyContainer}>
                  <RecentlyPosted blogs={blogs.slice(0,2)} />
                </div>
              )}
            </div>
            {isMobile && <RecentlyPostedMobile blogs={blogs.slice(0,2)} />}
            {!isMobile && (
              <div className={styles.individualBlogRightContainer}>
                <p className={styles.searchTagTitle}>Search With Tags</p>
                <SearchTags tags={Tags} />
                <AddContainer />
                <Categories />
                <TodaysUpdate />
                <InstagramPost />
              </div>
            )}
          </div>
        </div>
      </>
    </Suspense>
  );
};

export default IndividualBlog;
